import {
    GET_MASTER_VEHICLE_DATA,
    GET_ADD_MASTER_VEHICLE_DATA,
    SUCCESS_MESSAGE_MASTER_VEHICLE,
    ERROR_MESSAGE_MASTER_VEHICLE,
    HIDE_MESSAGE_MASTER_VEHICLE,
} from 'constants/ActionTypes';


let INIT_STATE = {
    alertMessageMasterVehicle: '',
    successMessageMasterVehicle: false,
    errorMessageMasterVehicle: false,
    masterVehicleData: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MASTER_VEHICLE_DATA: {
            return {
                ...state,
                masterVehicleData: action.payload
            }
        }
        case GET_ADD_MASTER_VEHICLE_DATA: {
            return {
                ...state,
                masterVehicleData: [...state.masterVehicleData, action.payload]
            }
        }
        case SUCCESS_MESSAGE_MASTER_VEHICLE: {
            return {
                ...state,
                alertMessageMasterVehicle: action.payload,
                successMessageMasterVehicle: true,
            }
        }
        case ERROR_MESSAGE_MASTER_VEHICLE: {
            return {
                ...state,
                alertMessageMasterVehicle: action.payload,
                errorMessageMasterVehicle: true,
            }
        }
        case HIDE_MESSAGE_MASTER_VEHICLE: {
            return {
                ...state,
                alertMessageMasterVehicle: '',
                errorMessageMasterVehicle: false,
                successMessageMasterVehicle: false,
            }
        }
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/MasterVehicle.js